<app-popup
  [isOpen]="showShapePicker()"
  [title]="dialogTitleKey() | translate"
  size="xsmall"
  variant="secondary"
  color="amarante"
  (closed)="cancel()">
  <div class="shape-choices">
    <app-button variant="secondary" color="amarante" [addIconLeft]="true" [label]="'POLYGON.POLYGON' | translate" (clicked)="chooseShape('polygon')">
      <img slot="icon-left" src="assets/icon/line.svg" alt="" />
    </app-button>
    <app-button variant="secondary" color="amarante" [addIconLeft]="true" [label]="'POLYGON.CIRCLE' | translate" (clicked)="chooseShape('circle')">
      <img slot="icon-left" src="assets/icon/circle.svg" alt="" />
    </app-button>
  </div>
</app-popup>

<app-popup
  [isOpen]="showPolygonForm()"
  [title]="'POLYGON.POLYGON' | translate"
  size="small"
  variant="secondary"
  color="amarante"
  (closed)="cancel()">
  <div class="field">
    <span class="field__label">{{ 'POLYGON.SELECT_BLAST' | translate }}</span>
    <app-select
      [options]="blastOptions()"
      [placeholder]="'POLYGON.SELECT_OR_CHANGE_BLAST' | translate"
      [ngModel]="blastId()"
      (ngModelChange)="blastId.set($event)" />
  </div>
  <div class="field">
    <span class="field__label">{{ 'POLYGON.SELECT_POLYGONE_TYPE' | translate }}</span>
    <app-select
      [options]="polygonTypeOptions()"
      [ngModel]="polygonType()"
      (ngModelChange)="polygonType.set($event)" />
  </div>
  <p class="confirm">{{ 'POLYGON.CONFIRM_CREATE_POLYGON' | translate }}</p>
  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GLOBAL.ANNULER' | translate" (clicked)="cancel()" />
    <app-button
      variant="primary"
      color="amarante"
      [label]="'GLOBAL.OUI' | translate"
      [state]="canSavePolygon() ? 'default' : 'disabled'"
      (clicked)="savePolygon()" />
  </ng-container>
</app-popup>

<app-popup
  [isOpen]="showZoneForm()"
  [title]="'ZOI.ZONE' | translate"
  size="small"
  variant="secondary"
  color="amarante"
  (closed)="cancel()">
  <div class="field">
    <span class="field__label">{{ 'ZOI.NAME' | translate }}</span>
    <app-input [maxlength]="100" [ngModel]="zoneName()" (ngModelChange)="zoneName.set($event)" />
  </div>
  <div class="field">
    <span class="field__label">{{ 'ZOI.TYPE' | translate }}</span>
    <app-select
      [options]="zoneTypeOptions()"
      [ngModel]="zoneType()"
      (ngModelChange)="zoneType.set($event)" />
  </div>
  <div class="field">
    <span class="field__label">{{ 'ZOI.THRESHOLD' | translate }}</span>
    <app-input type="number" [integer]="true" [ngModel]="zoneThreshold()" (ngModelChange)="zoneThreshold.set(+$event || 0)" />
  </div>
  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GLOBAL.ANNULER' | translate" (clicked)="cancel()" />
    <app-button
      variant="primary"
      color="amarante"
      [label]="'GLOBAL.VALIDER' | translate"
      [state]="canSaveZone() ? 'default' : 'disabled'"
      (clicked)="saveZone()" />
  </ng-container>
</app-popup>
